import OpenFaresWidget from "components/OpenFaresWidget/OpenFaresWidget";
import React, { useEffect } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";

export default function FlightWayRoute() {
  const location = useLocation();
  useEffect(() => {
    if (!location.pathname.startsWith("/flights")) return;

    const initWidget = async () => {
      // wait until script finished loading
      await window.__openfaresReady;

      const el = document.getElementById("ofEngine");
      if (!el) return;

      // reset container to avoid ghost instance
      el.innerHTML = "";

      window.OpenFares?.init();
    };

    initWidget();
  }, [location.pathname]);
  return (
    <section className="">
      {/* {location.pathname !== "/" ? (
        <div className="m-auto mt-5 flex flex-wrap items-center justify-between px-5 font-semibold text-gray-800 sm:mt-10">
          <fieldset className="flex gap-2">
            <Link to={"/flights/round-trip"}>
              <div className="flex items-center gap-2 rounded-full border bg-white px-3 py-0.5 text-sm">
                <div
                  className={`h-4 w-4 rounded-full border-2 border-gray-300 ${
                    location.pathname === "/flights/round-trip" ||
                    location.pathname === "/flights" ||
                    location.pathname === "/hotdeals"
                      ? "bg-red-400"
                      : ""
                  }`}
                ></div>

                <label
                  htmlFor="roundTrip"
                  className="cursor-pointer whitespace-nowrap"
                >
                  Round Trip
                </label>
              </div>
            </Link>
            <Link to={"/flights/oneway"}>
              <div className="flex items-center gap-2 rounded-full border bg-white px-2 py-0.5 text-sm">
                <div
                  className={`h-4 w-4 rounded-full border-2 border-gray-300 ${
                    location.pathname === "/flights/oneway" ? "bg-red-400" : ""
                  }`}
                ></div>
                <label
                  htmlFor="oneWay"
                  className="cursor-pointer whitespace-nowrap"
                >
                  One Way
                </label>
              </div>
            </Link>

            <Link to={"/flights/multi-city"}>
              <div className="flex items-center gap-2 rounded-full border bg-white px-3 py-0.5 text-sm">
                <div
                  className={`h-4 w-4 rounded-full border-2 border-gray-300 ${
                    location.pathname === "/flights/multi-city"
                      ? "bg-red-400"
                      : ""
                  }`}
                ></div>

                <label
                  htmlFor="multiCity"
                  className="cursor-pointer whitespace-nowrap"
                >
                  Multi City
                </label>
              </div>
            </Link>
          </fieldset>
          <div className="mt-2 sm:mt-0">
            Book International and Domestic Flights
          </div>
        </div>
      ) : (
        ""
      )}
      <Outlet /> */}
      {location.pathname === "/flights" ? (
        <>
          <div className="hide-scroll-bar container m-auto mt-5 overflow-y-auto font-semibold text-gray-800 sm:mt-10 sm:max-h-[480px] sm:min-h-[200px] sm:px-5">
            {/* Disclaimer */}
            <div className="mb-4 flex items-start gap-3 rounded-lg border border-blue-200 bg-blue-50 px-4 py-3 text-sm text-blue-900">
              <p className="font-normal leading-relaxed text-blue-900">
                The fares displayed are for reference and may vary based on
                availability and routing. Your booking is confirmed only after
                our travel experts review and verify all details to ensure
                accuracy. For exclusive fares, flexible options, or faster
                assistance, please call or WhatsApp
                <span className="ml-1 font-semibold">905-244-1300</span>.
              </p>
            </div>

            {/* Widget */}
            <div id="ofEngine" />
          </div>
        </>
      ) : (
        ""
      )}
    </section>
  );
}
